import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AnalyticsCoreURLService } from '../../../reporting/analytics-core/services/analytics-core.url.service';
import { StorageSessionService } from '../../storage/services/storage.session.service';
import { AuthService } from '../services/auth.service';

@Injectable()
export class AuthGuard implements CanActivate {
	constructor(
		private storageSessionService: StorageSessionService,
		private router: Router,
		private authService: AuthService,
		private analyticsCoreUrlService: AnalyticsCoreURLService
	) {}

	canActivate(
		next: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): Observable<boolean> | Promise<boolean> | boolean {
		return new Promise((resolve) => {
			this.storageSessionService.checkSession();
			state.url = state.url.split('?')[0];
			if (this.storageSessionService.hasSession) {
				const token = this.storageSessionService.token;
				this.authService
					.checkSession(this.analyticsCoreUrlService.serviceURL + '/analytics_module/check_logged_in')
					.subscribe((response: any) => {
						if (response.success) {
							if (state.url === '/' || state.url === '/login') {
								const queryParamsObj = this.storageSessionService.getQueryParamsObj();
								let nextRoute = '/dashboard';
								if (queryParamsObj['product']) {
									nextRoute = `${nextRoute}/${queryParamsObj['product']}`;
									delete queryParamsObj['product'];
								}
								this.router.navigate([nextRoute], { queryParams: queryParamsObj });
								resolve(true);
							} else {
								resolve(true);
							}
						} else {
							this.storageSessionService.clearToken();
							this.storageSessionService.clearServiceURL();
							if (state.url !== '/login') {
								this.router.navigate(['/login']);
								resolve(false);
							} else {
								resolve(true);
							}
						}
					});
			} else {
				if (state.url !== '/login') {
					this.storageSessionService.queryParams = window.location.search;
					this.storageSessionService.URLproductRoute = state.url;
					this.router.navigate(['/login']);
					resolve(false);
				} else {
					resolve(true);
				}
			}
		});
	}
}
